import axios from "axios";
import { baseGeospatial } from "../../../api/base/baseUrl";

const BASE_URL = "/api/v1/zone-geospatial";

export async function createZoneRequest(payload) {
  const response = await baseGeospatial.post(BASE_URL, payload);
  return response.data;
}

export async function getZoneListRequest() {
  const response = await baseGeospatial.get(`${BASE_URL}/get-all-list`);
  return response.data;
}

export async function getZoneByIdRequest(id) {
  const response = await baseGeospatial.get(`${BASE_URL}/get-by-id/${id}`);
  return response.data;
}

export async function updateZoneRequest(payload) {
  console.log("updateZoneRequest payload:", payload);
  const response = await baseGeospatial.put(`${BASE_URL}/update`, payload);
  return response.data;
}
